import httpService from '@/services/httpService';
import ApiEndpoints from '@/utils/ApiEndpoints';

export default {
    uploadFiles (data) {
        return httpService.postWithHeaders(ApiEndpoints.get('upload'), data, {
            headers: { 'X-AUTH-TOKEN': 'token' }
        });
    },
    getFamilyEditionConsentUri (data) {
        return ApiEndpoints.get('family_edition_consent_uri', {
            familyEditionId: data.familyId,
            consentFileId: data.consentFileId
        });
    },
    getFamilyToAcceptConsentUri (data) {
        return ApiEndpoints.get('family_to_accept_consent_uri', {
            familyToAcceptId: data.familyId,
            consentFileId: data.consentFileId
        });
    }
};
